<template>
  <div style="height: 100%" class="mt-n16 d-flex align-center justify-center">
    <div class="text-center">
      <v-icon color="red">mdi-alert-circle-outline</v-icon>
      <h3 class="mt-2">Unspecified error occurred.</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: "UnspecifiedError",
};
</script>
